module.exports = "/static/assets/e6283fbede8ac619c52897552aec251e.png";